import { styled } from '../../../lib/stitches'
import { gray1, gray9 } from '../../platform/color'

const StyledText = styled('span', {
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: 400,
  userSelect: 'none',
  cursor: 'default',
  variants: {
    small: {
      true: {
        fontSize: '10px',
        lineHeight: '10px'
      }
    },
    big: { true: { fontSize: '16px' } },
    b: { true: { fontWeight: 700 } },
    secondary: { true: { color: gray9 } },
    invert: { true: { color: gray1 } }
  }
})

const Text = StyledText

export default Text
